import { gql } from '@apollo/client';

export default gql`
  mutation deleteSessionInfo($id: ID!) {
    deleteSessionInfo(input: { id: $id }) {
      success
    }
  }
`;
